export const getOffsetHeight = () => {
  // Calculate navigation height.
  let navigationHeight = 0;
  // Offset for admin bar element.
  const adminBarElement = window.document.getElementById('adminbar');
  if (adminBarElement) {
    navigationHeight += adminBarElement.getBoundingClientRect().height;
  }
  // Offset for header element.
  const headerElement = window.document.querySelector('#page > .nav-header');
  if (headerElement) {
    const headerPosition = getComputedStyle(headerElement).position;
    if (headerPosition === 'sticky' || headerPosition === 'fixed') {
      const headerRect = headerElement.getBoundingClientRect();
      // Get distance from page top minus admin bar offset, and double it for an added buffer.
      navigationHeight += (headerRect.top - navigationHeight) * 2;
      // Add header height.
      navigationHeight += headerRect.height;
    }
  }
  if (navigationHeight < 0) {
    return 0;
  }
  return navigationHeight;
};
export const scrollTo = target => {
  if (!target) {
    return false;
  }
  if (typeof target === 'string') {
    target = document.querySelector(target);
    if (!target) {
      return false;
    }
  }

  // Go to the nearest section if it is the first heading.
  const isHeading = node => node && /^(H[1-6])$/i.test(node.nodeName);
  if (isHeading(target)) {
    const targetTemp = target.closest('section');
    if (targetTemp && targetTemp.querySelector('h1,h2,h3,h4,h5,h6') === target) {
      target = targetTemp;
    }
  }
  const navigationHeight = getOffsetHeight();
  const targetBoundingBox = target.getBoundingClientRect();
  const anchorOffset = (window.scrollY ? window.scrollY : document.documentElement.scrollTop ? document.documentElement.scrollTop : 0) + targetBoundingBox.top - navigationHeight;
  window.scrollTo({
    left: window.scrollX,
    top: anchorOffset,
    behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)') ? 'auto' : 'smooth'
  });
  return true;
};
export default scrollTo;